export default "__VITE_ASSET__gz_3UQPN__"